import React, { useEffect, useState } from 'react';
import { SparklesIcon } from 'lucide-react';
import { CART_URL } from '../data/content';
function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds);
  useEffect(() => {
    const id = setInterval(() => setRemaining(r => r > 0 ? r - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const h = String(Math.floor(remaining / 3600)).padStart(2, '0');
  const m = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
  const s = String(remaining % 60).padStart(2, '0');
  return {
    h,
    m,
    s
  };
}
export function AlertBar() {
  const {
    h,
    m,
    s
  } = useCountdown(3 * 3600 + 47 * 60);
  return <a href={CART_URL} className="sticky top-0 z-50 flex w-full items-center justify-center gap-x-3 gap-y-1 bg-green-deep px-4 py-2.5 text-center text-white transition-colors hover:bg-[#33502F]" data-id="element-16" data-mp="g80ryyx3h947">
      <SparklesIcon className="hidden h-4 w-4 shrink-0 text-yellow-brand sm:block" data-id="element-17" data-mp="30yrer7jip1ae" />
      <span className="text-xs font-bold uppercase tracking-wide sm:text-sm" data-id="element-18" data-mp="1sw78tyon8pr4">
        50% OFF por tiempo limitado — todos los bonos incluidos
      </span>
      <span className="flex items-center gap-1 rounded-full bg-yellow-brand px-2.5 py-0.5 font-mono text-xs font-extrabold text-green-deep tabular-nums" data-id="element-19" data-mp="1ow6ojxev5kc5">
        {h}:{m}:{s}
      </span>
    </a>;
}